<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="0">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add @invoke-method="$refs.tankManufacturerComponents.showTankManufacturersSpec()" permanent></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetTankManufacturer()" permanent></bc-btn-refresh>
                        </v-toolbar>
                    </v-layout>
                </v-container>
                <v-container grid-list-xl v-if="profile != null">
                    <v-layout row :wrap="$bp.smallScreen">
                        <v-flex xs12 md4 lg3 align-self-start pb-0 :pl-0="!$bp.smallScreen">
                            <v-layout row wrap>
                                <!-- <v-flex xs8 py-0>
                                    <bc-tooltip v-if="profile.has_user_account == 'Yes'" right :disabled="!allow_people_update">
                                        <template slot="activator">
                                            <v-btn
                                                v-if="allow_people_update"
                                                style="max-width: 120px; text-transform: none;"
                                                class="pl-1"
                                                round
                                                selected
                                                :color="profile.status_class"
                                                text-color="white"
                                                @mouseup.left="dbChangedStatus()"
                                            >
                                                <v-icon color="white" class="mr-2" v-model="editStatus.users.status">{{status_loader ? "fas fa-circle-notch fa-spin" : "check_circle"}}</v-icon>
                                                <span class="white--text">{{ profile && profile.login_type ? $t(`lang.${profile.login_type}`) : $t('lang.loading') }}</span>
                                            </v-btn>
                                            <v-chip v-else disabled round text-color="white" class="chip-padding-left-4 mr-auto fs-14" :color="profile.status_class">
                                                <span><v-icon class="mr-2">check_circle</v-icon></span>
                                                <span class="white--text">{{ $t(`lang.${profile.login_type}`) }}</span>
                                            </v-chip>
                                        </template>
                                        {{ editStatus.users.status == 0 ? $t('lang.click_to_activate') : $t('lang.click_to_deactivate') }}
                                    </bc-tooltip>
                                    <bc-btn-add
                                        v-else
                                        @invoke-method="invokeMethod($event)"
                                        action="openNewUserDialog"
                                        :tooltip="$t('lang.activate_user_account')"
                                        right
                                        permanent
                                    >
                                    </bc-btn-add>
                                </v-flex>
                                <v-flex xs4 pr-0 py-0>
                                    <bc-tooltip class="ml-auto" perm="people.update" v-if="allow_people_update">
                                        <template slot="activator">
                                            <v-btn @click="openTankManufacturerDialog()" icon>
                                                <v-icon color="indigo">edit</v-icon>
                                            </v-btn>
                                        </template>
                                        {{ $t('lang.modify_person') }}
                                    </bc-tooltip>
                                </v-flex> -->
                                <!-- <v-flex xs12 py-0 :class="{ 'prevent-click': !allow_people_update }">
                                    <bc-tooltip top>
                                        <template slot="activator">
                                            <v-img
                                                :src="showErrorImg ? errorImg : profile.photo"
                                                height="150px"
                                                width="150px"
                                                class="rounded-circle mx-auto clickable"
                                                :key="updatePhoto"
                                                @error="showErrorImg = true"
                                            ></v-img>
                                        </template>
                                        {{ $t('lang.uploadImage') }}
                                    </bc-tooltip>
                                </v-flex> -->
                                <v-flex class="py-1 clickable" @mouseup.left="openTankManufacturerDialog()">
                                    <p class="display-1 mb-0 text-xs-center underline-hover">{{ profile.manufacturer }}</p>
                                    <!-- <p class="display-0 mb-0 text-xs-center">{{ profile.phone }}</p> -->
                                </v-flex>
                            </v-layout>
                            <v-divider class="my-0"></v-divider>
                            <bc-list prepend-icon="info" @invoke-method="openTankManufacturerDialog()">
                                <template>
                                    <v-layout row wrap pr-1 py-2 pl-2>
                                        <v-flex d-inline xs12 mt-1
                                            >{{ `${$t("lang.contact_name")}:` }}
                                            <span class="fw-semi-bold">{{ currObjField("contact_name") || "---" }}</span></v-flex
                                        >
                                        <v-flex d-inline xs12 mt-1
                                            >{{ `${$t("lang.phone")}:` }} <span class="fw-semi-bold">{{ currObjField("phone") || "---" }}</span></v-flex
                                        >
                                        <v-flex d-inline xs12 mt-1
                                            >{{ `${$t("lang.email")}:` }} <span class="fw-semi-bold">{{ currObjField("email") || "---" }}</span></v-flex
                                        >
                                        <v-flex d-inline xs12 mt-1
                                            >{{ `${$t("lang.website")}:` }} <span class="fw-semi-bold">{{ currObjField("website") || "---" }}</span></v-flex
                                        >
                                        <v-flex d-inline xs12 mt-1
                                            >{{ `${$t("lang.notes")}:` }}
                                            <span class="fw-semi-bold text-pre-line">{{ (currObjField("notes") || "---") | shrink_text(250) }}</span></v-flex
                                        >
                                    </v-layout>
                                </template>
                            </bc-list>
                        </v-flex>
                        <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs12 md8 lg9 :pr-0="!$bp.smallScreen" :pl-4="!$bp.smallScreen" align-self-start>
                            <div>
                                <v-card elevation="0">
                                    <keep-alive>
                                        <component
                                            v-if="profile"
                                            ref="tankManufacturerComponents"
                                            :is="`tank_manufacturer_${selectedComponent}`"
                                            class="tab"
                                        ></component>
                                    </keep-alive>
                                </v-card>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-container>
        <bc-dialog :value="tank_manufacturer_dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ currObjField("manufacturer_id") ? $t("lang.edit_tank_manufacturer") : $t("lang.add_tank_manufacturer") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        action="closeTankManufacturerDialog"
                        :dialog-status="tank_manufacturer_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="tank_manufacturer">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-text-field
                                        v-focus="tank_manufacturer_dialog"
                                        v-model="tank_manufacturer.manufacturer"
                                        :label="`${$t('lang.manufacturer')} *`"
                                        :counter="showCounter(tank_manufacturer.manufacturer, 'tank_manufacturer.manufacturer')"
                                        :rules="ifValid('tank_manufacturer.manufacturer')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="tank_manufacturer.contact_name"
                                        :label="$t('lang.contact_name')"
                                        :counter="showCounter(tank_manufacturer.contact_name, 'tank_manufacturer.contact_name')"
                                        :rules="ifValid('tank_manufacturer.contact_name')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="tank_manufacturer.phone"
                                        :label="$t('lang.phone')"
                                        :counter="showCounter(tank_manufacturer.phone, 'tank_manufacturer.phone')"
                                        :rules="ifValid('tank_manufacturer.phone')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="tank_manufacturer.email"
                                        :label="$t('lang.email')"
                                        :counter="showCounter(tank_manufacturer.email, 'tank_manufacturer.email')"
                                        :rules="ifValid('tank_manufacturer.email')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="tank_manufacturer.website"
                                        :label="$t('lang.website')"
                                        :counter="showCounter(tank_manufacturer.website, 'tank_manufacturer.website')"
                                        :rules="ifValid('tank_manufacturer.website')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-textarea
                                        v-model="tank_manufacturer.notes"
                                        :label="$t('lang.notes')"
                                        auto-grow
                                        rows="1"
                                        :rules="ifValid('tank_manufacturer.notes')"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="currObjField('manufacturer_id')" color="error" @mouseup.left="$refs.delete_tank_manufacturer.openDialog()">{{
                        $t("lang.delete")
                    }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closeTankManufacturerDialog()">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="modifyTankManufacturer('patch', currObjField('manufacturer_id'))">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <delete-confirmation-dialog
            ref="delete_tank_manufacturer"
            :heading="$t('lang.delete_tank_manufacturer')"
            :message="$t('lang.confirm_delete_message')"
            @onConfirm="modifyTankManufacturer('delete', currObjField('manufacturer_id'))"
        ></delete-confirmation-dialog>
    </div>
</template>

<script>
import tank_manufacturer_specs from "Modules/configuration/tank_manufacturers/components/Specs";
import { store } from "Store/store";
import { mapGetters, mapState } from "vuex";

export default {
    data() {
        return {
            selectedComponent: "specs",
            dbGetTankManufacturer: _.debounce(this.getTankManufacturer, 1500, {
                maxWait: 1500,
                leading: true,
                trailing: false,
            }),
            tabs: [
                {
                    title: "specs",
                    name: "specs",
                    slug: ["employee", "customer", "distributor"],
                },
            ],
            tank_manufacturer_dialog: false,
            tank_manufacturer: {
                manufacturer: "",
                contact_name: "",
                phone: "",
                email: "",
                website: "",
                notes: "",
            },
            addList: [
                {
                    title: this.$t("lang.addNumber"),
                    action: "showPhone",
                    ref: "phoneDialog",
                    icon: "phone",
                },
                {
                    title: this.$t("lang.addEmail"),
                    action: "showEmail",
                    ref: "emailDialog",
                    icon: "email",
                },
                {
                    title: this.$t("lang.addAddress"),
                    action: "showAddress",
                    ref: "addressDialog",
                    icon: "location_on",
                },
                {
                    title: this.$t("lang.addToken"),
                    action: "openTokenDialog",
                    icon: "generating_tokens",
                },
            ],
            mobileList: [
                {
                    title: this.$t("lang.addNumber"),
                    action: "showPhone",
                    ref: "phoneDialog",
                },
                {
                    title: this.$t("lang.addEmail"),
                    action: "showEmail",
                    ref: "emailDialog",
                },
                {
                    title: this.$t("lang.addAddress"),
                    action: "showAddress",
                    ref: "addressDialog",
                },
                { title: this.$t("lang.addToken"), action: "openTokenDialog" },
                { title: this.$t("lang.refresh"), action: "dbGetPeople" },
            ],
        };
    },
    beforeRouteEnter(to, from, next) {
        store
            .dispatch("fetchTankManufacturer", {
                url: "tank_manufacturers/" + to.params.id,
                method: "get",
                stateProperty: "tank_manufacturer",
                dataProperty: "tank_manufacturers",
                commit: true,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.tank_manufacturers) {
                    next((vm) => {
                        vm.finishLoader();
                        vm.$store.commit("validationOff");
                        vm.$store.commit("toggleModalLoader", false);
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        this.$store
            .dispatch("fetchTankManufacturer", {
                url: "tank_manufacturers/" + to.params.id,
                method: "get",
                stateProperty: "tank_manufacturer",
                dataProperty: "tank_manufacturers",
                commit: true,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.tank_manufacturers) {
                    this.finishLoader();
                    this.$store.commit("validationOff");
                    this.$store.commit("toggleModalLoader", false);
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_tank_manufacturer: (state) => state.validation.rules_tank_manufacturer,
            profile: (state) => state.tank_manufacturers.tank_manufacturer,
        }),
        ...mapGetters(["login_types"]),
        currObjField() {
            return (field) => {
                return this.profile && field && this.profile[field] ? this.profile[field] : "";
            };
        },
    },
    methods: {
        getTankManufacturer(status = true) {
            if (status) this.startLoader();
            this.$store
                .dispatch("fetchTankManufacturer", {
                    url: "tank_manufacturers/" + this.$route.params.id,
                    method: "get",
                    stateProperty: "tank_manufacturer",
                    dataProperty: "tank_manufacturers",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.tank_manufacturers) {
                        this.finishLoader(true);
                        this.$store.commit("validationOff");
                        this.$store.commit("toggleModalLoader", false);
                    } else {
                        this.$router.push({ name: "dashboard", replace: true });
                    }
                })
                .catch((error) => {
                    this.finishLoader();
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.$router.push({ name: "dashboard", replace: true });
                });
        },
        closeTankManufacturerDialog() {
            this.tank_manufacturer_dialog = false;
            this.$refs.delete_tank_manufacturer.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        modifyTankManufacturer(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("tank_manufacturer")) {
                        // ensure notes is trimmed properly
                        let data = this.removeExtraNewlines(this.tank_manufacturer, 2, "notes");
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchTankManufacturer", {
                                pk: "manufacturer_id",
                                id: id,
                                url: `tank_manufacturers/${id ? id : ""}`,
                                method: method,
                                stateProperty: "tank_manufacturer",
                                dataProperty: "tank_manufacturers",
                                commit: method != "delete",
                                body: method != "delete" ? data : "",
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    if (method == "delete") {
                                        this.$router.push({
                                            name: "settings_tank_manufacturers",
                                        });
                                    }
                                    this.closeTankManufacturerDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        openTankManufacturerDialog() {
            this.assignObj(this.tank_manufacturer, this.profile, this.rules_tank_manufacturer);
            this.tank_manufacturer_dialog = true;
            if (this.$refs.tank_manufacturer) this.$refs.tank_manufacturer.resetValidation();
        },
    },
    components: {
        tank_manufacturer_specs,
    },
};
</script>
